import { EventLogApiModel } from '../../../../types/models/event-log.model';
import { GetEventLogApiRequest } from '../../../../types/requests/event-logs/get-event-log.request';
import { SearchEventLogsApiRequest } from '../../../../types/requests/event-logs/search-event-logs.request';
import { getEventLog, searchEventLogs } from '../../api/event-logs.api';
import { useAxiosInfiniteQuery, useAxiosQuery } from './use-axios.hook';

const baseQueryKey = 'event-log';
const searchQueryKey = 'search';

export const useGetEventLog = <T extends EventLogApiModel>(params: GetEventLogApiRequest) => {
  const { data, ...result } = useAxiosQuery<T>({
    queryKey: [baseQueryKey, params],
    queryFn: async () => (await getEventLog<T>(params)).data,
    enabled: Boolean(params.eventLogId && !Number.isNaN(params.eventLogId)),
  });
  return { ...result, eventLog: data } as const;
};

export const useSearchEventLogs = (params: SearchEventLogsApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchEventLogs({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
